const isSingleSelect = (select) => {
    return "nodeName" in select;
};
export const getApplicationOptionsFromForm = (form) => {
    var _a;
    const applicationOptions = [];
    if (isSingleSelect(form["application"])) {
        applicationOptions.push(parseInt(form["application"].value, 10));
    }
    else {
        (_a = form["application"]) === null || _a === void 0 ? void 0 : _a.forEach((select) => {
            if (select.value) {
                applicationOptions.push(parseInt(select.value, 10));
            }
        });
    }
    return applicationOptions.filter((id) => !isNaN(id));
};
//# sourceMappingURL=getApplicationOptionsFromForm.js.map
